import React, { Component } from "react";
import Modal from 'react-bootstrap/Modal';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Actions, { thunks } from '../../redux/modules/products';
import Loader from "../Loader";
import ImagePlaceholder from '../../assets/img/img_placeholder.jpg';
import { formatCategory } from '../../utils/format';
import Pagination from '../Pagination';
import _, { debounce } from 'lodash';

class CombineProductsModal extends Component {

    componentDidMount(){
        this.props.dispatch(thunks.getCategories());
    }

    onSearchTextChange = _.debounce((e) => {
        const { value } = e.target ? e.target : '';
        const { updateProperty, dispatch } = this.props;
        updateProperty('searchText', value);
        if (value) {
            dispatch(thunks.searchProducts(value))
        } else {
            dispatch(thunks.getCategories());
        }
    }, 300);

    onCategoryChange = e => {
       
        const { value } = e.target;
        const { updateProperty, dispatch } = this.props;
        updateProperty('parentCategoryID', value);
        dispatch(thunks.getCategories(value));
    }
    onSubCategoryChange = e => {
        const { updateProperty, dispatch } = this.props;
        updateProperty('parentSubCategoryID', e.target.value);
        dispatch(thunks.getProducts());
    }

    selectProduct = product => {
        this.props.onSelect(product);
    }
    onNext = () => {
        const { dispatch } = this.props;
        dispatch(thunks.loadMoreProducts());
    }
    render() {
        const {
            show,
            onHide,
            onSelect,
            parentCategoryID,
            categories,
            subCategories,
            parentSubCategoryID,
            list,
            loading,
            error,
            nextPageToken,
        } = this.props;
        return (
            <Modal
                show={show}
                onHide={onHide}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Product Search
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row mb-3">
                        <div className="col-md-4">
                            <div className="form-group">
                                <label>Category</label>
                                <select
                                    className="form-control"
                                    value={parentCategoryID}
                                    onChange={this.onCategoryChange}
                                >
                                    {categories.map(category => <option key={category.id} value={category.id}>{category.displayName}</option>)}
                                </select>
                            </div>
                        </div>
                        {!!subCategories.length && (
                            <div className="col-md-4">
                                <div className="form-group">
                                    <label>Subcategory</label>
                                    <select
                                        className="form-control"
                                        value={parentSubCategoryID}
                                        onChange={this.onSubCategoryChange}
                                    >
                                        {subCategories.map(category => <option key={category.id} value={category.id}>{category.displayName}</option>)}
                                    </select>
                                </div>
                            </div>
                        )}
                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>Search</label>
                                                <input placeholder="Enter product title"
                                                    className="form-control"
                                                    onChange={this.onSearchTextChange}
                                                />
                                            </div>
                                        </div>
                           <div className="col-md-12">
                            <div className="table-responsive">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Title</th>
                                            <th>Image</th>
                                            <th>Category</th>
                                            <th/>
                                        </tr>
                                    </thead>
                                    <tbody>
                                            {
                                                loading ? (
                                                    <tr>
                                                        <td colSpan="5" className="text-center">
                                                            <Loader show noOverlay/>
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    list.length ? (
                                                        list.map(product => (
                                                            <tr key={product.productId}>
                                                                <td>{product.productId}</td>
                                                                <td>{product.title}</td>
                                                                <td>
                                                                    {<img src={product.productImages.length ? product.productImages[0] : ImagePlaceholder} alt={product.title} width="80px"/>}    
                                                                </td>
                                                                <td>{formatCategory(product.categoryName)}</td>
                                                                <td>
                                                                    <button title="Select" className="btn btn-xs btn-primary ml-2" onClick={() => this.selectProduct(product)}>
                                                                        <i className="fa fa-plus"/>
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        error ? (
                                                            <tr>
                                                                <td colSpan="5" className="text-center">{error}</td>
                                                            </tr>
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="5" className="text-center">No Products Found</td>
                                                            </tr>
                                                        )
                                                    )
                                                )
                                            }
                                    </tbody>
                                </table>
                            </div>
                            <Pagination
                                nextPageToken={nextPageToken}
                                onNext={this.onNext}
                            />
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

        )
    }

}
const mapStateToProps = ({
    products: {
        loading,
        error,
        list,
        nextPageToken,
        categories,
        subCategories,
        parentCategoryID,
        parentSubCategoryID,
        message,
    },
}) => ({
    loading,
    error,
    list,
    nextPageToken,
    categories,
    subCategories,
    parentCategoryID,
    parentSubCategoryID,
    message,
});
const mapDispatchToProps = dispatch => ({
    dispatch,
    updateProperty: bindActionCreators(Actions, dispatch).updateProperty,
    reset: bindActionCreators(Actions, dispatch).reset,
});

export default connect(mapStateToProps, mapDispatchToProps)(CombineProductsModal)
// export default CombineProductsModal